module.exports = __webpack_public_path__ + "front/img/51.b16e6c84.png";